import { memo } from 'react';

// Thẻ BÌNH CHỌN trong đoạn chat. Hiện câu hỏi + từng phương án kèm thanh % và số phiếu.
// Bấm 1 phương án để chọn/bỏ (multi thì chọn nhiều). Người tạo/GĐ có thể "Đóng" để chốt kết quả.
function PollCard({ message, myId, onVote, onClose, canClose, onPeek }) {
  const poll = message.poll;
  if (!poll) return null;
  const votes = poll.votes || [];
  const total = votes.length; // tổng lượt bình chọn (multi có thể > số người)
  const voters = new Set(votes.map((v) => String(v.user))).size; // số NGƯỜI đã bình chọn
  const closed = !!poll.closed;

  return (
    <div className="poll-card">
      <div className="poll-head">
        <span className="poll-icon">📊</span>
        <span className="poll-q">{poll.question}</span>
      </div>
      <div className="poll-sub">
        {poll.multi ? 'Chọn nhiều phương án · ' : ''}
        {voters} người đã bình chọn{closed ? ' · Đã đóng' : ''}
      </div>
      <div className="poll-opts">
        {poll.options.map((o, i) => {
          const optVotes = votes.filter((v) => v.option === i);
          const n = optVotes.length;
          const pct = total ? Math.round((n / total) * 100) : 0;
          const mine = optVotes.some((v) => String(v.user) === String(myId));
          return (
            <button
              type="button"
              key={i}
              className={'poll-opt' + (mine ? ' mine' : '') + (closed ? ' closed' : '')}
              disabled={closed}
              onClick={() => !closed && onVote(message, i)}
              title={closed ? 'Bình chọn đã đóng' : mine ? 'Bấm để bỏ chọn' : 'Bấm để chọn'}
            >
              <span className="poll-bar" style={{ width: pct + '%' }} />
              <span className="poll-opt-in">
                <span className="poll-check">{mine ? '☑' : '☐'}</span>
                <span className="poll-opt-text">{o.text}</span>
                <span
                  className="poll-count"
                  onClick={(e) => { e.stopPropagation(); if (n) onPeek?.({ title: o.text, lines: optVotes.map((v) => ({ icon: '🗳', name: v.name || 'Ai đó' })) }); }}
                >
                  {n}
                </span>
              </span>
            </button>
          );
        })}
      </div>
      {canClose && !closed && (
        <button type="button" className="poll-close-btn" onClick={() => onClose(message)}>
          Đóng bình chọn
        </button>
      )}
    </div>
  );
}

export default memo(PollCard);
